<ng-container *ngIf="forceDisplayOfBackButton || isNotProximusPlusMobileApp">
  <ng-container [ngSwitch]="backButtonType">
    <ng-container *ngSwitchCase="'lastButton'">
      <a (click)="navigate()" class="rs-btn"
        >{{ customLabel || 'bills.callDetails.backLabel' | translate }}
      </a>
    </ng-container>
    <ng-container *ngSwitchCase="'firstButton'">
      <div class="rs-flex-column rs-flex-shrink rs-order-m1">
        <a (click)="navigate()" class="rs-btn rs-btn-second rs-btn-nl-m"
          >{{ customLabel || 'bills.callDetails.backLabel' | translate }}
        </a>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'firstButtonWithLeftArrow'">
      <div class="rs-flex-column rs-flex-shrink rs-order-m1">
        <a (click)="navigate()" class="rs-btn rs-btn-prev"
          ><i
            class="icon-Arrowbutton-left rs-margin-right1"
            aria-hidden="true"
          ></i
          >{{ customLabel || 'bills.callDetails.backLabel' | translate }}
        </a>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'firstButtonWithLeftArrowNoMarginLeft'">
      <a (click)="navigate()" class="rs-btn rs-btn-prev"
        ><i
          class="icon-Arrowbutton-left rs-margin-right1"
          aria-hidden="true"
        ></i
        >{{ customLabel || 'bills.callDetails.backLabel' | translate }}
      </a>
    </ng-container>

    <ng-container *ngSwitchCase="'leftArrowPlainText'">
      <a
        (click)="navigate()"
        class="rs-btn rs-btn-third rs-btn-neg rs-btn-third-icon-left"
        ><i class="rs-icon-btn-third rs-margin-right1" aria-hidden="true"></i
        >{{ customLabel || 'bills.callDetails.backLabel' | translate }}
      </a>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <div class="rs-flex-column rs-flex-shrink rs-order-m1">
        <a (click)="navigate()" class="rs-btn rs-btn-prev"
          ><i
            class="icon-Arrowbutton-left rs-margin-right1"
            aria-hidden="true"
          ></i
          >{{ customLabel || 'bills.callDetails.backLabel' | translate }}
        </a>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
